module.exports = __webpack_public_path__ + "static/media/home.e84c0683.svg";